import { IPatient } from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';
import { IBaseCommand, IBridgeIntegration } from '../../send-command-to-device';

export const DTX_STUDIO_DRIVER_DIRECT_INTEGRATION: IBridgeIntegration = {
  label: 'DTX Studio Driver Direct',
  description:
    'Acquire radiographic images directly through DTX Studio Driver, without DTX Core',
};

export type DtxStudioDriverDirectIntegrationCommand = IBaseCommand<
  DtxStudioDriverDirectToDeviceCommand,
  { patient: WithRef<IPatient> }
>;

export enum DtxStudioDriverDirectToDeviceCommand {
  TriggerImageCapture = 'dtxStudioDriverDirect.triggerImageCapture',
}
